import { FC, useRef, useState } from 'react'
import styles from './footer-nav-column.module.scss'
import ChevronDownEmptyIcon from '@/components/icons/ChevronDownEmptyIcon'
import IFooterNavItem from '@/types/footer-nav-item.interface'
import FooterNavItem from './FooterNavItem'
import { useTranslation } from 'react-i18next'
import classNames from '@/utils/helpers/class-names.helper'

type FooterNavColumnProps = {
  titleI18n: string
  items: IFooterNavItem[]
  withoutSchema?: boolean
}

const FooterNavColumn: FC<FooterNavColumnProps> = ({ titleI18n, items, withoutSchema }) => {
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)

  const [active, setActive] = useState<boolean>(false)

  const toggleActive = () => {
    setActive((state) => !state)
  }

  const list = (
    <ul
      className={styles.list}
      style={active ? { maxHeight: `${ref.current?.nextElementSibling?.scrollHeight}px` } : {}}
      {...(!withoutSchema
        ? { itemScope: true, itemType: 'https://schema.org/SiteNavigationElement' }
        : {})}
    >
      {items.map((item, index) => (
        <FooterNavItem key={`footer_nav_item_${titleI18n}_${index}`} {...item} />
      ))}
    </ul>
  )

  return (
    <div className={styles.column}>
      <div
        onClick={toggleActive}
        ref={ref}
        className={classNames(styles.header, active && '_active')}
      >
        <div className={styles.title}>{t(titleI18n)}</div>
        <ChevronDownEmptyIcon className={styles.icon} />
      </div>
      {list}
    </div>
  )
}

export default FooterNavColumn
